<template>
  <span class="check-box">
    <input
      v-model="checked"
      :name="name"
      :disabled="disabled"
      class="toggle"
      type="checkbox"
    >
    <label
      @click="onClick"
      :for="name"
      :class="{ 'disabled' : disabled }"
    ></label>
    <span v-html="label" class="label" @click.prevent="doubleClick">
    </span>
  </span>
</template>
<script>
import { Checkbox } from "element-ui";

export default {
  name: "l-checkbox",
  components: {
    [Checkbox.name]: Checkbox
  },
  props: {
    value: {
      type: [Boolean, Number]
    },
    required: {
      type: Boolean
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String
    }
    // name: {
    //   type: String,
    //   required: false,
    //   default: ''
    // }
  },
  data() {
    return {
      name: this.$helpers.createId()
    }
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
        this.$emit('on-change');
        this.$emit('change');
      }
    }
  },
  mounted() {
    if (this.checked === '1') this.checked = true;
  },
  methods: {
    onClick() {
      if (this.disabled) return;

      this.checked = !this.checked;
      this.$emit('on-click', this.checked);
    },
    doubleClick() {
      if (this.disabled) return;
      this.$emit('on-click-label');
    }
  }
};
</script>

<style scoped>

.disabled {
  opacity: 0.9;
  cursor: not-allowed;
}

.check-box {
  /* display: flex;
  transition: all 0.4s;
  justify-content: space-between;
  justify-items: center;
  align-items: center; */
}
input {
  display: none;
}
.toggle {
	text-align: center;
	width: 40px;
	/* auto, since non-WebKit browsers doesn't support input styling */
	height: 50px;
	position: absolute;
	top: 10;
	bottom: 10;
	margin: auto 0;
	border: none; /* Mobile Safari */
	-webkit-appearance: none;
	appearance: none;
}

.toggle {
	opacity: 0;
}

.label {
  padding-left: 10px;
}

label {
  /* transition: background-image 0.3s ease; */
  cursor: pointer;
	background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTIgMmM1LjUxNCAwIDEwIDQuNDg2IDEwIDEwcy00LjQ4NiAxMC0xMCAxMC0xMC00LjQ4Ni0xMC0xMCA0LjQ4Ni0xMCAxMC0xMHptMC0yYy02LjYyNyAwLTEyIDUuMzczLTEyIDEyczUuMzczIDEyIDEyIDEyIDEyLTUuMzczIDEyLTEyLTUuMzczLTEyLTEyLTEyeiIvPjwvc3ZnPg==");
	background-repeat: no-repeat;
	/* background-position: 15px center; */
  background-size: 30px;
  opacity: 0.5;
  word-break: break-all;
  padding: 10px 15px 15px 15px;
  display: inline;
  line-height: 1.2;
  transition: color 0.4s;
}

.toggle:checked + label {
  /* transition: background-image 0.3s ease; */
  background-size: 37px;
  background-position-x: center;
  padding: 15px 15px 10px 15px;
	/* background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTIgMmM1LjUxNCAwIDEwIDQuNDg2IDEwIDEwcy00LjQ4NiAxMC0xMCAxMC0xMC00LjQ4Ni0xMC0xMCA0LjQ4Ni0xMCAxMC0xMHptMC0yYy02LjYyNyAwLTEyIDUuMzczLTEyIDEyczUuMzczIDEyIDEyIDEyIDEyLTUuMzczIDEyLTEyLTUuMzczLTEyLTEyLTEyem00LjM5MyA3LjVsLTUuNjQzIDUuNzg0LTIuNjQ0LTIuNTA2LTEuODU2IDEuODU4IDQuNSA0LjM2NCA3LjUtNy42NDMtMS44NTctMS44NTd6Ii8+PC9zdmc+"); */
	background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE4LjEuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDQ4IDQ4IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0OCA0ODsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGNpcmNsZSBzdHlsZT0iZmlsbDojQzhFNkM5OyIgY3g9IjI0IiBjeT0iMjQiIHI9IjE5Ii8+DQo8cG9seWdvbiBzdHlsZT0iZmlsbDojNENBRjUwOyIgcG9pbnRzPSIzNC41ODUsMTQuNTg2IDIxLjAxNCwyOC4xNzIgMTUuNDEzLDIyLjU4NCAxMi41ODcsMjUuNDE2IDIxLjAxOSwzMy44MjggMzcuNDE1LDE3LjQxNCAiLz4NCjwvc3ZnPg0K");
}


.todo-list li.completed label {
	text-decoration: line-through;
}
</style>
